<template>
	<layout-admin>
		<span class="p-4"
			><b>Achtung:</b> Euronext Preise werden aktualisiert, wenn ein Kontrakt
			gehandelt wurde. Abhängig von der Liquidität eines einzelnen Kontrakts
			kann sich der zuletzt gehandelte Preis häufiger oder seltener ändern</span
		>

		<admin-crop-grid
			title="Aktuelle Euronext Preise"
			:rows="data"
			:cols="cols"
			v-bind:row-href="rowHref"
			:defaultOrderByAscending="false"
		/>
	</layout-admin>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		data: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			cols: [
				{
					id: "symbol",
					name: "Symbol",
				},
				{
					id: "name",
					name: "Name",
				},
				{
					id: "euronext_price",
					name: "Euronext Last Traded",
				},
				{
					id: "euronext_date",
					name: "Euronext Kurszeit",
				},
			],
		};
	},
	methods: {
		rowHref(row) {
			return "#";
		},
	},
};
</script>
